module.exports = __webpack_public_path__ + "img/ICmeter.dd20ab7d.png";